
export function getLanguage(data, i18n) {
    if (!data) {
        return '';
    }
    if (!data[i18n.language]) {
        return data["en"]
    }
    return data[i18n.language]
}